/* ============================================
   SIDE CART — Shopify Theme JavaScript
   (Hidden product approach for Shipping Protection)
   ============================================ */

(function() {
  var CONFIG = window.__SC_CONFIG__ || {};

  function normalizeMilestoneAmount(value) {
    // Accepts whole currency units (e.g. 50 for €50) and converts to cents
    var raw = String(value == null ? '' : value).trim();
    if (!raw) return 0;

    var cleaned = raw.replace(/[^0-9.]/g, '');
    if (!cleaned) return 0;

    var numeric = parseFloat(cleaned);
    if (!isFinite(numeric) || numeric <= 0) return 0;

    // Always treat as whole currency units → multiply by 100 for cents
    return Math.round(numeric * 100);
  }

  function normalizeMilestones(milestones) {
    return (milestones || [])
      .map(function(m) {
        return {
          label: String((m && m.label) || '').trim(),
          amount: normalizeMilestoneAmount(m && m.amount)
        };
      })
      .filter(function(m) {
        return m.label && m.amount > 0;
      })
      .sort(function(a, b) {
        return a.amount - b.amount;
      });
  }

  var SETTINGS = {
    openOnIconClick: CONFIG.openOnIconClick !== false,
    openOnAddToCart: CONFIG.openOnAdd !== false,
    showTimer: CONFIG.showTimer !== false,
    timerMinutes: CONFIG.timerMinutes || 5,
    showShippingBar: CONFIG.showBar !== false,
    showShippingProtection: CONFIG.showProtection !== false,
    protectionVariantId: CONFIG.protectionVariantId || null,
    protectionPrice: parseFloat(CONFIG.protectionPrice || '4.99'),
    showSavings: CONFIG.showSavings !== false,
    milestones: normalizeMilestones(CONFIG.milestones || [])
  };

  if (SETTINGS.milestones.length === 0) {
    SETTINGS.milestones = normalizeMilestones([
      { label: 'Free Shipping', amount: 50 },
      { label: 'Free Scent', amount: 80 },
      { label: 'Free Gift', amount: 130 }
    ]);
  }

  var ICONS = [
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>',
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_3387_7485)"><path d="M18.09 10.37C19.0353 10.7224 19.8765 11.3075 20.5358 12.0712C21.195 12.8349 21.6511 13.7524 21.8617 14.7391C22.0724 15.7257 22.0309 16.7495 21.741 17.7158C21.4512 18.6822 20.9223 19.5598 20.2034 20.2676C19.4845 20.9754 18.5987 21.4905 17.628 21.7652C16.6572 22.04 15.6329 22.0655 14.6497 21.8395C13.6665 21.6134 12.7561 21.1431 12.0028 20.472C11.2495 19.8009 10.6776 18.9507 10.34 18M7 6H8V10M16.71 13.88L17.41 14.59L14.59 17.41M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z" stroke="#5C7159" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_3387_7485"><rect width="23.1485" height="23.1485" fill="white"/></clipPath></defs></svg>',
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 8.00044V21.0004M12 8.00044C11.6383 6.50984 11.0154 5.2355 10.2127 4.3436C9.41003 3.4517 8.46469 2.98363 7.5 3.00044C6.83696 3.00044 6.20107 3.26383 5.73223 3.73267C5.26339 4.20151 5 4.8374 5 5.50044C5 6.16348 5.26339 6.79936 5.73223 7.2682C6.20107 7.73705 6.83696 8.00044 7.5 8.00044M12 8.00044C12.3617 6.50984 12.9846 5.2355 13.7873 4.3436C14.59 3.4517 15.5353 2.98363 16.5 3.00044C17.163 3.00044 17.7989 3.26383 18.2678 3.73267C18.7366 4.20151 19 4.8374 19 5.50044C19 6.16348 18.7366 6.79936 18.2678 7.2682C17.7989 7.73705 17.163 8.00044 16.5 8.00044M19 12.0004V19.0004C19 19.5309 18.7893 20.0396 18.4142 20.4146C18.0391 20.7897 17.5304 21.0004 17 21.0004H7C6.46957 21.0004 5.96086 20.7897 5.58579 20.4146C5.21071 20.0396 5 19.5309 5 19.0004V12.0004M4 8.00044H20C20.5523 8.00044 21 8.44815 21 9.00044V11.0004C21 11.5527 20.5523 12.0004 20 12.0004H4C3.44772 12.0004 3 11.5527 3 11.0004V9.00044C3 8.44815 3.44772 8.00044 4 8.00044Z" stroke="#5C7159" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  ];
  var timerSeconds = SETTINGS.timerMinutes * 60;
  var timerInterval = null;

  var $ = function(sel) { return document.querySelector(sel); };
  var $$ = function(sel) { return document.querySelectorAll(sel); };

  function delay(ms) {
    return new Promise(function(resolve) {
      setTimeout(resolve, ms);
    });
  }

  /* ---------- Currency formatting ---------- */
  function formatMoney(cents) {
    var currency = CONFIG.currency || 'EUR';
    var amount = (cents / 100).toFixed(2);
    if (currency === 'EUR') return '€' + amount;
    if (currency === 'GBP') return '£' + amount;
    return '$' + amount;
  }

  /* ---------- Cart Open / Close ---------- */
  window.SideCart = {
    open: function() {
      $('#side-cart')?.classList.add('is-open');
      $('#side-cart-overlay')?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      startTimer();
      refreshCart();
    },

    close: function() {
      $('#side-cart')?.classList.remove('is-open');
      $('#side-cart-overlay')?.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    updateQty: async function(key, qty) {
      if (qty < 0) qty = 0;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      refreshCart();
    },

    removeItem: async function(key) {
      await this.updateQty(key, 0);
    },

    clearAll: async function() {
      await fetch('/cart/clear.js', { method: 'POST' });
      refreshCart();
    },

    /* --- Shipping Protection Toggle --- */
    toggleProtection: async function(checked) {
      var variantId = String(SETTINGS.protectionVariantId || '').trim();
      if (!variantId) {
        console.warn('SideCart: No protectionVariantId configured in theme settings.');
        return;
      }

      var toggleEl = $('#sc-protection-toggle');
      if (toggleEl) toggleEl.disabled = true;

      try {
        var cart = await fetchCart();
        var protItem = getProtectionItem(cart);

        if (checked) {
          if (protItem && protItem.quantity > 1) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: protItem.key, quantity: 1 })
            });
          } else if (!protItem) {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
            });
          }
        }

        if (!checked && protItem) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: protItem.key, quantity: 0 })
          });
        }

        cart = await waitForProtectionState(checked);
        renderItems(cart);
        renderCounts(cart);
        renderShippingBar(cart);
        renderFooter(cart);
        syncProtectionToggle(cart);
        updateProtectionPriceDisplay(cart);
      } finally {
        if (toggleEl) toggleEl.disabled = false;
      }
    }
  };

  /* ---------- Refresh Cart via AJAX ---------- */
  async function refreshCart() {
    try {
      var cart = await fetchCart();
      cart = await normalizeProtectionItem(cart);

      var displayItems = getDisplayItems(cart);

      // If the only item left is the hidden protection product, auto-remove it
      if (displayItems.length === 0) {
        var protItem = getProtectionItem(cart);
        if (protItem) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: protItem.key, quantity: 0 })
          });
          cart = await fetchCart();
        }
      }

      renderItems(cart);
      renderCounts(cart);
      renderShippingBar(cart);
      renderFooter(cart);
      syncProtectionToggle(cart);
      updateProtectionPriceDisplay(cart);
      try { if (typeof window.updateCartCount === 'function') window.updateCartCount(cart.item_count); } catch(_) {}
    } catch (e) {
      console.error('SideCart: refresh error', e);
    }
  }

  async function fetchCart() {
    var res = await fetch('/cart.js?sc=' + Date.now(), {
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache'
      }
    });
    if (!res.ok) throw new Error('Unable to load cart');
    return res.json();
  }

  function getProtectionItem(cart) {
    if (!SETTINGS.protectionVariantId) return null;
    return cart.items.find(function(i) {
      return String(i.variant_id) === String(SETTINGS.protectionVariantId);
    }) || null;
  }

  async function normalizeProtectionItem(cart) {
    var protItem = getProtectionItem(cart);
    if (!protItem || protItem.quantity <= 1) return cart;

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: protItem.key, quantity: 1 })
    });

    return fetchCart();
  }

  async function waitForProtectionState(checked) {
    for (var attempt = 0; attempt < 6; attempt += 1) {
      var cart = await fetchCart();
      var protItem = getProtectionItem(cart);
      if (protItem && protItem.quantity > 1) {
        return normalizeProtectionItem(cart);
      }
      var inCart = !!protItem;
      if (inCart === checked) return cart;
      await delay(250);
    }

    return normalizeProtectionItem(await fetchCart());
  }

  /* ---------- Update protection price from actual product ---------- */
  function updateProtectionPriceDisplay(cart) {
    var priceEl = $('#sc-protection-price');
    if (!priceEl) return;

    if (SETTINGS.protectionVariantId) {
      var protItem = cart.items.find(function(i) {
        return String(i.variant_id) === String(SETTINGS.protectionVariantId);
      });
      if (protItem) {
        priceEl.textContent = formatMoney(protItem.price);
        return;
      }
    }

    // Fallback: use the price from theme settings (convert dollars to cents)
    var priceCents = Math.round(SETTINGS.protectionPrice * 100);
    priceEl.textContent = formatMoney(priceCents);
  }

  /* ---------- Sync protection toggle with cart state ---------- */
  function syncProtectionToggle(cart) {
    var toggle = $('#sc-protection-toggle');
    if (!toggle || !SETTINGS.protectionVariantId) return;
    var inCart = !!getProtectionItem(cart);
    toggle.checked = inCart;
  }

  function renderCounts(cart) {
    var displayCount = getDisplayItems(cart).reduce(function(s, i) { return s + i.quantity; }, 0);
    $$('#sc-item-count').forEach(function(el) { el.textContent = String(displayCount).padStart(2, '0'); });
    var textEl = $('#sc-item-count-text');
    if (textEl) textEl.textContent = displayCount;
    $$('[data-cart-count]').forEach(function(el) {
      el.textContent = displayCount;
      el.style.display = displayCount > 0 ? '' : 'none';
    });
    $$('.sc-title-outer').forEach(function(el) {
      el.style.display = displayCount > 0 ? '' : 'none';
    });
  }

  function getDisplayItems(cart) {
    return cart.items.filter(function(i) {
      return String(i.variant_id) !== String(SETTINGS.protectionVariantId);
    });
  }

  function renderItems(cart) {
    var container = $('#sc-items');
    var wrapper = $('.side-cart-inner');
    if (!container) return;

    var items = getDisplayItems(cart);

    if (items.length === 0) {
      wrapper.classList.add('emptycartsec');
      container.innerHTML = '<div class="sc-empty"><div class="empty-img"><img src="https://cdn.shopify.com/s/files/1/1035/8430/1390/files/image_36.webp?v=1782302989"/></div><p class="emptyc">Your cart is empty</p><div class="btn-main pad-bt00"><button type="button" class="first-btn shipbtn" onclick="window.location.href=\'https://www.timeo-pro-demo-1.com/\';"><span>Continue Shopping</span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-right-icon lucide-arrow-right"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></button></div></div>';
      return;
    } else {
      wrapper.classList.remove('emptycartsec');

    }

    var html = '';
    items.forEach(function(item) {
      var compareHtml = item.original_price > item.final_price
        ? '<span class="sc-item-compare">' + formatMoney(item.original_price) + '</span>' : '';

      html += '<div class="sc-item" data-key="' + item.key + '">' +
        '<div class="sc-item-image">' +
          '<img src="' + getSizedImage(item.image, '128x') + '" alt="' + escHtml(item.title) + '" loading="lazy" width="64" height="64">' +
        '</div>' +
        '<div class="sc-item-details">' +
          '<h4 class="sc-item-title">' + escHtml(item.product_title) + '</h4>' +
          '<div class="sc-item-qty">' +
            '<button class="sc-qty-btn" onclick="SideCart.updateQty(\'' + item.key + '\', ' + (item.quantity - 1) + ')">' +
              '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
            '</button>' +
            '<span>' + String(item.quantity).padStart(2, '0') + '</span>' +
            '<button class="sc-qty-btn" onclick="SideCart.updateQty(\'' + item.key + '\', ' + (item.quantity + 1) + ')">' +
              '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>' +
        '<div class="sc-item-prices">' +
          '<span class="sc-item-price">' + formatMoney(item.final_line_price) + '</span>' +
          compareHtml +
          '<button class="sc-item-remove" onclick="SideCart.removeItem(\'' + item.key + '\')">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash2-icon lucide-trash-2"><path d="M10 11v6"/><path d="M14 11v6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>' +
          '</button>' +
        '</div>' +
      '</div>';
    });

    html += '<button class="sc-clear-all" onclick="SideCart.clearAll()">Clear All</button>';
    container.innerHTML = html;
  }

  function renderShippingBar(cart) {
    if (!SETTINGS.showShippingBar) return;

    var displayItems = getDisplayItems(cart);
    var displayTotal = displayItems.reduce(function(s, i) { return s + i.final_line_price; }, 0);

    var shippingEl = $('#sc-shipping-progress');
    var timerEl = $('#sc-timer');
    if (displayItems.length === 0) {
      if (shippingEl) shippingEl.style.display = 'none';
      if (timerEl) timerEl.style.display = 'none';
      return;
    }

    if (shippingEl) shippingEl.style.display = '';
    if (timerEl) timerEl.style.display = '';

    var milestones = SETTINGS.milestones;
    if (!milestones.length) return;

    var nextMilestone = milestones.find(function(m) {
      return displayTotal < m.amount;
    }) || null;
    var previousMilestone = null;

    milestones.forEach(function(m) {
      if (displayTotal >= m.amount) {
        previousMilestone = m;
      }
    });

    var maxAmount = Math.max(milestones[milestones.length - 1].amount, 1);
    var progress = Math.min((displayTotal / maxAmount) * 100, 100);
    var remaining = nextMilestone ? Math.max(0, nextMilestone.amount - displayTotal) : 0;

    var textEl = $('#sc-shipping-text');
    var barEl = $('#sc-progress-bar');
    var iconsEl = $('#sc-milestone-icons');

    if (textEl) {
      textEl.innerHTML = nextMilestone
        ? 'You\'re <strong>' + formatMoney(remaining) + '</strong> away from <strong>' + escHtml(nextMilestone.label) + '</strong>'
        : '🎉 You\'ve unlocked all rewards!';
    }
    if (barEl) barEl.style.width = progress + '%';
    if (iconsEl) {
      iconsEl.innerHTML = milestones.map(function(m, i) {
        var reached = displayTotal >= m.amount;
        return '<div class="sc-milestone">' +
          '<div class="sc-milestone-dot ' + (reached ? 'reached' : 'pending') + '">' + (ICONS[i] || '📦') + '</div>' +
          '<span class="sc-milestone-label">' + escHtml(m.label) + '</span>' +
        '</div>';
      }).join('');
    }
  }

  function renderFooter(cart) {
    var displayItems = getDisplayItems(cart);

    var footerEl = $('.sc-footer');
    if (footerEl) {
      footerEl.style.display = displayItems.length === 0 ? 'none' : '';
    }

    var savings = displayItems.reduce(function(sum, item) {
      return sum + (item.original_line_price - item.final_line_price);
    }, 0);

    var savingsEl = $('#sc-savings');
    var savingsAmountEl = $('#sc-savings-amount');
    if (savingsEl && SETTINGS.showSavings) {
      if (savings > 0) {
        savingsEl.style.display = '';
        if (savingsAmountEl) savingsAmountEl.textContent = formatMoney(savings);
      } else {
        savingsEl.style.display = 'none';
      }
    }

    var displayTotal = displayItems.reduce(function(s, i) { return s + i.final_line_price; }, 0);

    var protItem = getProtectionItem(cart);
    var protectionAmount = protItem ? protItem.final_price : 0;

    var grandTotal = displayTotal + protectionAmount;

    var subtotalEl = $('#sc-subtotal-amount');
    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(grandTotal);
      subtotalEl.dataset.cents = grandTotal;
    }

    var checkoutTotalEl = $('#sc-checkout-total');
    if (checkoutTotalEl) {
      checkoutTotalEl.textContent = formatMoney(grandTotal);
    }
  }

  /* ---------- Timer ---------- */
  function startTimer() {
    if (!SETTINGS.showTimer || timerInterval) return;
    updateTimerDisplay();
    timerInterval = setInterval(function() {
      timerSeconds = Math.max(0, timerSeconds - 1);
      updateTimerDisplay();
      if (timerSeconds <= 0) clearInterval(timerInterval);
    }, 1000);
  }

  function updateTimerDisplay() {
    var el = $('#sc-timer-display');
    if (!el) return;
    var h = Math.floor(timerSeconds / 3600);
    var m = Math.floor((timerSeconds % 3600) / 60);
    var s = timerSeconds % 60;
    el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
  }
  function pad(n) { return String(n).padStart(2, '0'); }

  /* ---------- Helpers ---------- */
  function getSizedImage(src, size) {
    if (!src) return '';
    return src.replace(/(\.[^.]+)$/, '_' + size + '$1');
  }

  function escHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  /* ---------- Header Snapshot Guard ----------
     Dawn's product-form posts /cart/add with a `sections=` param that includes
     the header section. Dawn then replaces the live header HTML with the
     server-rendered markup, which on add-to-cart can come back as the mobile
     <header-drawer> variant and "smash" the desktop header. We snapshot the
     existing desktop header before the request and restore it immediately
     after, so only the cart count (handled by updateCartCount) changes. */
  function snapshotHeader() {
    var headers = document.querySelectorAll('.header-wrapper, .section-header, #shopify-section-header, sticky-header');
    var snaps = [];
    headers.forEach(function(h) {
      // Only snapshot if we currently have the desktop inline menu — that's the
      // markup we want to preserve. Skip if the page is already in mobile state.
      if (h.querySelector('.header__inline-menu')) {
        snaps.push({ el: h, html: h.innerHTML });
      }
    });
    return snaps;
  }
  function restoreHeader(snaps) {
    if (!snaps || !snaps.length) return;
    snaps.forEach(function(s) {
      // If Dawn swapped it to <header-drawer> (mobile markup), put desktop back.
      if (!s.el.querySelector('.header__inline-menu')) {
        s.el.innerHTML = s.html;
      }
    });
  }

  /* ---------- Intercept Add-to-Cart Forms ---------- */
  function interceptAddToCart() {
    if (!SETTINGS.openOnAddToCart) return;

    document.addEventListener('submit', async function(e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;

      e.preventDefault();
      e.stopPropagation();
      var formData = new FormData(form);
      // Strip Dawn's section-rerender request so it can't overwrite our header.
      try { formData.delete('sections'); formData.delete('sections_url'); } catch(_) {}

      var snaps = snapshotHeader();
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        restoreHeader(snaps);
        try { if (typeof window.updateCartCount === 'function') await window.updateCartCount(); } catch(_) {}
        SideCart.open();
      } catch (err) {
        console.error('SideCart: add to cart error', err);
        restoreHeader(snaps);
        form.submit();
      }
    }, true);

    var originalFetch = window.fetch;
    window.fetch = function() {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : args[0]?.url;

      // Block Dawn's post-add-to-cart "?sections=header" rerender request.
      // Dawn fetches the header section HTML and swaps it into the live DOM,
      // which on this theme returns the mobile <header-drawer> markup and
      // smashes the desktop header. We short-circuit it by returning the
      // CURRENT header HTML so Dawn's swap is a no-op.
      if (url && /[?&]sections=/.test(url) && /sections=[^&]*header/.test(url)) {
        var headerSection = document.getElementById('shopify-section-header');
        var payload = {};
        if (headerSection) {
          payload.header = headerSection.outerHTML;
        }
        return Promise.resolve(new Response(JSON.stringify(payload), {
          status: 200,
          headers: { 'Content-Type': 'application/json' }
        }));
      }

      if (url && url.includes('/cart/add')) {
        var snaps = snapshotHeader();
        return originalFetch.apply(this, args).then(function(res) {
          restoreHeader(snaps);
          setTimeout(function() { restoreHeader(snaps); }, 0);
          setTimeout(function() { restoreHeader(snaps); }, 50);
          setTimeout(function() { restoreHeader(snaps); }, 200);
          if (res.ok) {
            try { if (typeof window.updateCartCount === 'function') window.updateCartCount(); } catch(_) {}
            if (SETTINGS.openOnAddToCart) {
              setTimeout(function() { SideCart.open(); }, 100);
            }
          }
          return res;
        }).catch(function(err) {
          restoreHeader(snaps);
          throw err;
        });
      }
      return originalFetch.apply(this, args);
    };
  }

  /* ---------- Bind Icon Click ---------- */
  function bindIconClick() {
    document.querySelectorAll('[data-cart-trigger], .cart-icon-link, a[href="/cart"]').forEach(function(el) {
      el.addEventListener('click', function(e) {
        if (SETTINGS.openOnIconClick) {
          e.preventDefault();
          e.stopPropagation();
          SideCart.open();
        }
      }, true);
    });
  }

  /* ---------- Patch Dawn product-form component ---------- */
  function patchProductForm() {
    if (!SETTINGS.openOnAddToCart) return;

    var patch = function() {
      document.querySelectorAll('product-form').forEach(function(pf) {
        if (pf.__sc_patched) return;
        pf.__sc_patched = true;

        var origSubmit = pf.onSubmitHandler;
        if (typeof origSubmit === 'function') {
          pf.onSubmitHandler = async function(evt) {
            evt.preventDefault();
            var form = pf.querySelector('form');
            if (!form) return;
            var formData = new FormData(form);
            try { formData.delete('sections'); formData.delete('sections_url'); } catch(_) {}
            var snaps = snapshotHeader();
            try {
              await fetch('/cart/add.js', { method: 'POST', body: formData });
              restoreHeader(snaps);
              setTimeout(function() { restoreHeader(snaps); }, 50);
              try { if (typeof window.updateCartCount === 'function') await window.updateCartCount(); } catch(_) {}
              SideCart.open();
            } catch (err) {
              restoreHeader(snaps);
              console.error('SideCart: patched add error', err);
            }
          };
        }
      });
    };

    patch();
    new MutationObserver(patch).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Bind Protection Toggle ---------- */
  function bindProtectionToggle() {
    var toggle = $('#sc-protection-toggle');
    if (toggle) {
      toggle.addEventListener('change', function() {
        SideCart.toggleProtection(this.checked);
      });
    }
  }

  function enableCartIcon() {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon) {
      cartIcon.classList.remove('disabled-cart');
      cartIcon.style.pointerEvents = 'auto';
    }
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function() {
    interceptAddToCart();
    bindIconClick();
    enableCartIcon();
    patchProductForm();
    bindProtectionToggle();
    try { if (typeof window.updateCartCount === 'function') window.updateCartCount(); } catch(_) {}

    // Set initial protection price display from settings
    var priceEl = $('#sc-protection-price');
    if (priceEl) {
      var priceCents = Math.round(SETTINGS.protectionPrice * 100);
      priceEl.textContent = formatMoney(priceCents);
    }
  });

})();




function updateCartCount(countOverride) {
  // Targets where we are ALLOWED to create a new bubble if missing (mobile-specific only).
  // Desktop header uses its own markup and creating extra nodes there breaks its layout.
  var CREATE_SELECTORS = '.mm-cart-btn';

  function setBubbleText(bubble, count) {
    var span = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
    if (span) span.textContent = count;
    var sr = bubble.querySelector('.visually-hidden');
    if (sr) sr.textContent = count + ' items';
    bubble.style.display = '';
  }

  function applyCount(count) {
    // 1) Update any EXISTING .cart-count-bubble in the document (covers desktop header,
    //    Dawn's #cart-icon-bubble, etc.) — never create new nodes here.
    document.querySelectorAll('.cart-count-bubble').forEach(function(bubble) {
      if (count > 0) {
        setBubbleText(bubble, count);
      } else {
        bubble.parentNode && bubble.parentNode.removeChild(bubble);
      }
    });

    // 2) For mobile-only targets, create a bubble if it doesn't exist yet.
    document.querySelectorAll(CREATE_SELECTORS).forEach(function(target) {
      var bubble = target.querySelector('.cart-count-bubble');
      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          var span = document.createElement('span');
          span.setAttribute('aria-hidden', 'true');
          span.textContent = count;
          bubble.appendChild(span);
          var sr = document.createElement('span');
          sr.className = 'visually-hidden';
          sr.textContent = count + ' items';
          bubble.appendChild(sr);
          target.appendChild(bubble);
        } else {
          setBubbleText(bubble, count);
        }
      }
    });
  }

  if (typeof countOverride === 'number') {
    applyCount(countOverride);
    return Promise.resolve(countOverride);
  }

  return fetch('/cart.js', { headers: { 'Cache-Control': 'no-cache' } })
    .then(function(res) { return res.json(); })
    .then(function(cart) { applyCount(cart.item_count); return cart.item_count; })
    .catch(function(err) { console.error('Cart update error:', err); });
}
window.updateCartCount = updateCartCount;



// TAB SWITCH
document.addEventListener('click', function(e) {
  if (e.target.closest('.sc-toggle-link')) {
    const btn = e.target.closest('.sc-toggle-link');
    const tab = btn.dataset.tab;

    document.querySelectorAll('.sc-toggle-link').forEach(b => b.classList.remove('active'));
    document.querySelectorAll('.sc-tab-content').forEach(t => t.classList.remove('active'));

    btn.classList.add('active');

    if (tab === 'promo') {
      document.getElementById('sc-promo-tab').classList.add('active');
    } else {
      document.getElementById('sc-note-tab').classList.add('active');
    }
  }
});


SideCart.applyDiscount = function() {
  const code = document.getElementById('sc-promo-input').value.trim();
  if (!code) return;

  localStorage.setItem('sc_discount_code', code);

  let msg = document.querySelector('.sc-promo-success');
  if (!msg) {
    msg = document.createElement('div');
    msg.className = 'sc-promo-success';
    document.querySelector('.sc-extra-options').appendChild(msg);
  }

  msg.innerHTML = `✓ Promo code "${code}" applied`;

  SideCart.recalculateEstimate(); // 👈 important
};



SideCart.recalculateEstimate = function() {
  const subtotalEl = document.getElementById('sc-subtotal-amount');
  const originalText = subtotalEl.innerText.replace(/[^0-9.]/g, '');
  const original = parseFloat(originalText);

  const code = localStorage.getItem('sc_discount_code');

  let discount = 0;

  // 🔥 DEFINE YOUR PROMO RULES HERE
  if (code === 'timeo10') {
    discount = original * 0.10;
  } else if (code === 'SAVE50') {
    discount = 50;
  } else {
    discount = 0;
  }

  const newTotal = Math.max(0, original - discount);

  // Update subtotal visually
  subtotalEl.innerText = `$${newTotal.toFixed(2)}`;

  // Show savings (optional)
  let savings = document.getElementById('sc-savings-amount');
  if (savings) {
    savings.innerText = `-$${discount.toFixed(2)}`;
    document.getElementById('sc-savings').style.display = 'flex';
  }
};


document.addEventListener('DOMContentLoaded', function() {
  const saved = localStorage.getItem('sc_discount_code');
  if (saved) {
    document.getElementById('sc-promo-input').value = saved;
    SideCart.recalculateEstimate();
  }
});


// SAVE CART NOTE
document.addEventListener('change', function(e) {
  if (e.target.id === 'sc-cart-note') {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: e.target.value })
    });
  }
});



document.getElementById('sc-checkout-btn').addEventListener('click', function(e) {
  const code = localStorage.getItem('sc_discount_code');

  if (code) {
    e.preventDefault();
    window.location.href = `/discount/${code}?redirect=/checkout`;
  }
});
